// ============================================================
// MODIFIER PRESETS - the user's own situational modifiers, kept.
//
// localStorage rather than anything synced: a modifier palette is a
// GM's personal shorthand, not table state - and the affliction palette
// already learned that folder handles and sessions are the wrong
// lifetime for this kind of stationery (see effectPalette.ts).
// A preset is identified by label AND value - labels repeat freely
// ('Situational' +10 and 'Situational' -10 are different presets).
// Corrupt storage reads as empty.
// ============================================================

export interface ModifierPreset {
  label: string;
  value: number;
}

const KEY = 'dw-attack-mod-presets-v1';

export function loadModifierPresets(): ModifierPreset[] {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed.filter(
      (p): p is ModifierPreset => !!p && typeof p.label === 'string' && typeof p.value === 'number' && p.value !== 0,
    );
  } catch {
    return [];
  }
}

export function saveModifierPreset(preset: ModifierPreset): ModifierPreset[] {
  const next = [
    ...loadModifierPresets().filter((p) => !(p.label === preset.label && p.value === preset.value)),
    preset,
  ];
  localStorage.setItem(KEY, JSON.stringify(next));
  return next;
}

export function deleteModifierPreset(label: string, value: number): ModifierPreset[] {
  const next = loadModifierPresets().filter((p) => !(p.label === label && p.value === value));
  localStorage.setItem(KEY, JSON.stringify(next));
  return next;
}
